import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { DealerAdmin } from "../Transport Account/DealerProvider";
import io from "socket.io-client";

const Sidebar = () => {
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { dealerDetails } = DealerAdmin();
  const [records, setRecords] = useState(0);
  const socketConnected = useRef(false);
  const token = sessionStorage.getItem("authTokenDealer");

  const isActiveLink = (path) => location.pathname === path;

  const fetchRecords = async () => {
    if (!token) return;
    
    try {
      const response = await axios.get("https://zoomautos.co.uk/api/Subcontract", {
        headers: { Authorization: `Bearer ${token}` },
        params: { _t: new Date().getTime() } // Bypass cache
      });

      const filteredData = response.data.filter(
        (item) => item.status === "Active" && item.viewbyclient === false
      );

      setRecords(filteredData.length);
    } catch (error) {
      console.error("❌ Error fetching records:", error);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  useEffect(() => {
    if (location.pathname === "/Companies/ActiveJobs") {
      console.log("🔄 Navigated to ActiveJobs - Updating view status...");

      const updateViewStatus = async () => {
        try {
          const response = await axios.get("https://zoomautos.co.uk/api/Subcontract", {
            headers: { Authorization: `Bearer ${token}` },
            params: { _t: new Date().getTime() }
          });

          const filteredData = response.data.filter(
            (item) => item.status === "Active" && item.viewbyclient === false
          );

          await Promise.all(
            filteredData.map((item) =>
              axios.patch(`https://zoomautos.co.uk/api/Subcontract/${item.jobId}`, {
                viewbyclient: true
              }, {
                headers: { Authorization: `Bearer ${token}` }
              })
            )
          );

          setRecords(0); // Clear the count immediately
          console.log("✅ View status updated!");
        } catch (error) {
          console.error("❌ Error updating view status:", error);
        }
      };

      updateViewStatus();
    }
  }, [location.pathname]); // Runs only when pathname changes

  const socketRef = useRef(null);

  useEffect(() => {
    console.log("🟢 useEffect triggered - Checking socket connection...");
  
    if (!dealerDetails?.Id || !token) {
      console.warn("⚠️ dealerDetails.Id or token is undefined. Waiting...");
      return;
    }
  
    if (!socketRef.current) {
      console.log("🔄 Connecting to Socket.IO...");
      const socket = io("https://zoomautos.co.uk", {
        transports: ["polling"],
      });
      
      socket.on("connect", () => {
        console.log("✅ Connected to Socket.IO:", socket.id);
        if (dealerDetails?.Id) {
          console.log("📡 Registering user on connect:", dealerDetails.Id);
          socket.emit("register", dealerDetails.Id);
        }
      });
  
      socket.on("jobUpdated", (data) => {
        console.log("📩 Received jobUpdated event:", data);
        fetchRecords();
      });
  
      socket.on("disconnect", () => {
        console.log("🔴 Socket disconnected! Attempting to reconnect...");
      });
  
      socket.on("connect_error", (err) => {
        console.error("❌ Connection error:", err);
      });
  
      socketRef.current = socket;
    }
  
    return () => {
      console.log("🛑 Cleaning up socket listeners...");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [dealerDetails?.Id, token]);
  
  const handleLogout = () => {
    sessionStorage.removeItem("authTokenDealer");
    localStorage.removeItem("DealerData");

    if (socketConnected.current) {
      console.log("🛑 Disconnecting socket on logout...");
      socketConnected.current.disconnect();
      socketConnected.current = null;
    }

    navigate("/Logistics/Login");
  };

  return (
    <div>
      {/* Top Navbar */}
      <nav className="top-navbar">
        <button className="sidenav-toggle" onClick={() => setIsActive(!isActive)}>
          &#9776;
        </button>
        <div className="navbar-actions">
          <button className="login-btn" onClick={handleLogout}>LogOut</button>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`sidenav ${isActive ? "active" : ""}`}>
        <div className="sidenav-logo">
          <Link to="/move">
            <img src="/Logo4.png" alt="Logo" />
          </Link>
        </div>

        <button className="close-btn" onClick={() => setIsActive(false)}>
          &times;
        </button>

        <ul>
          <li>
            <Link to="/Companies/Home" className={isActiveLink("/Companies/Home") ? "active-link" : ""}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/Companies/Subcontract" className={isActiveLink("/Companies/Subcontract") ? "active-link" : ""}>
              Get A Quote
            </Link>
          </li>
          <li>
            <Link to="/Companies/Pending" className={isActiveLink("/Companies/Pending") ? "active-link" : ""}>
              Pending Quotes
            </Link>
          </li>
          <li>
            <Link to="/Companies/ActiveJobs" className={isActiveLink("/Companies/ActiveJobs") ? "active-link" : ""}>
              Active Jobs 
              {records > 0 && <span className="quote-count">{records}</span>}
            </Link>
          </li>
          <li>
            <Link to="/Companies/Completed" className={isActiveLink("/Companies/Completed") ? "active-link" : ""}>
              Completed Jobs
            </Link>
          </li>
          <li>
            <Link to="/Companies/Edit" className={isActiveLink("/Companies/Edit") ? "active-link" : ""}>
              Edit Profile
            </Link>
          </li>
          <li>
            <Link to="/Companies/Completed/Review" className={isActiveLink("/Companies/Completed/Review") ? "active-link" : ""}>
              Feedback
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
